import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, SECONDARY, PRIMARY } from '@glu/buttons-react';
import useStyles from './Footer.styles';
import LocaleContext from '../../../locale';

const FooterComponent = ({ onCancel, onNext }) => {
  const classes = useStyles();
  const locale = useContext(LocaleContext);

  return (
    <div className={classnames(classes.wrapper)}>
      {onNext && (
        <Button
          variant={PRIMARY}
          className="btn btn-primary"
          data-qa="next"
          type="button"
          onClick={onNext}
        >
          {locale['common.next']}
        </Button>
      )}
      <Button
        variant={SECONDARY}
        className="btn btn-secondary"
        data-qa="cancel"
        type="button"
        onClick={onCancel}
      >
        {locale['common.close']}
      </Button>
    </div>
  );
};

FooterComponent.propTypes = {
  onCancel: PropTypes.func,
  onNext: PropTypes.func
};

FooterComponent.defaultProps = {
  onCancel: null,
  onNext: null
};

export default FooterComponent;
